<template>
  <div class="article-card__header">
    <!-- Аватар -->
    <div v-if="card.avatar || card.firstName" class="article-card__avatar">
      <Avatar
        v-if="card.avatar"
        :avatar="card.avatar"
        class="article-card__avatar-img"
        width=20
      />
      <span v-else-if="card.firstName" class="article-card__avatar-noImg"
        >{{ card.firstName.substr(0, 1) }}{{ card.lastName.substr(0, 1) }}</span
      >
    </div>

    <!-- Имя -->
    <span
      v-if="card.firstName"
      class="article-card__name mr-6"
      itemprop="author"
      itemscope
      itemtype="http://schema.org/Person"
      :title="authorName"
    >
      <span itemprop="name">{{ authorName }}</span>
    </span>

    <!-- Название компании -->
    <a
      v-if="card.companyNameShort"
      :href="manufacturerLink"
      target="_blank"
      :class="{ 'd-none d-md-inline-block': !isArticlePage }"
      class="article-card__company mr-6"
      :title="card.companyNameShort"
    >
      <span itemprop="publisher" itemscope itemtype="http://schema.org/Organization">
        <span itemprop="name">{{ card.companyNameShort }}</span>
      </span>
    </a>

    <!-- Дата создания -->
    <time
      v-if="card.lang_versions"
      class="article-card__dateCreate d-none d-md-inline-block mr-6"
      :class="{ isArticlePage }"
      itemprop="datePublished"
      :datetime="new Date(card.lang_versions[1].public_date).toISOString()"
    >
      {{ card.lang_versions[1].public_date | date('date') }}
    </time>
    <time
      v-else-if="card.public_date"
      class="article-card__dateCreate d-none d-md-inline-block mr-6"
      :class="{ isArticlePage }"
      itemprop="datePublished"
      :datetime="new Date(card.public_date).toISOString()"
    >
      {{ card.public_date | date('date') }}
    </time>

    <!-- Количество просмотров -->
      <!-- v-if="isArticlePage" -->
    <span
      v-if="!isMainPage"
      class="article-card__views mr-6"
      :class="{ isArticlePage, 'd-none d-md-inline-block': isArticlePage }"
    >
      <i class="icon-views-eye"></i>
      {{ card.quant_user_views || card.lang_versions[1].quant_user_views }}
    </span>
     <span v-if="$windowWidth >= 961 && !isPreview" class="article-card__readingTime" :class="{isArticlePage}">
       <img src="/dist/assets/front_white/img/icons/clock.svg" alt="cloack"> {{ card.time_read || card.lang_versions[1].time_read  }} мин
     </span>
    <!-- <button class="article-card__btn-more ml-auto"><i class="icon-dots"></i></button> -->
  </div>
</template>

<script>
import Avatar from '@/components/Avatar'
export default {
  components: {
    Avatar
  },
  props: {
    card: {
      type: Object,
      required: true,
    },
    isArticlePage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    authorName() {
      return `${this.card.firstName || ""} ${this.card.lastName || ""}`
    },
    manufacturerId() {
      return this.card.organization_uuid
    },
    isPreview () {
      return window.location.search.includes("?preview")
    },
    isMainPage () {
      return location.pathname === '/'
    },
    manufacturerLink () {
      if (this.card.companyAccountType === 'manufacturer') {
        return `/manufacturer/${this.card.alias_organization || 'company'}/${this.manufacturerId}`
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
